module.exports = __webpack_public_path__ + "img/aboutUs_hero_wGradient.96ba1cd1.png";